module.exports = __webpack_public_path__ + "assets/img/Fvvg1TFzJiV-nt7vjaUNkoXyRrRw.81dca9d8.png";